"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ACTIVE: 'active',
    DELETED: 'deleted',
};
//# sourceMappingURL=commonStatus.js.map